import script from "./PlansCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansCalendar.vue?vue&type=script&setup=true&lang=js"

import "./PlansCalendar.vue?vue&type=style&index=0&id=0f1861f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1861f6"]])

export default __exports__